export default {
  DISCLOSURES_HEADER:
    "The following disclosures and statements govern your account with Bright Investment Advisors.",
  DISCLOSURES_SUBHEADINGS: [
    "By checking the box below I acknowledge and agree to the terms and conditions of the Investment Advisory Agreement.",
    "I understand that the Bright subscription fee is due if I am receiving financial counseling services (i.e. impersonal investment advice) whether or not I elect to open an account. I understand that if I select to open a Bright Account, I am required to complete the Suitability Questionnaire, and receive approval from Bright in order to open such account and obtain personalized investment advice.",
    "By checking where indicated below I acknowledge I have carefully reviewed and agree to each of the agreements listed, which I am encouraged to download and save. I am signing the consent for SSA to disclose my SSN Verification to Bright included in the terms of your Advisory Agreement. I agree that my electronic signature has the same legal meaning validity, and effect as my handwritten signature.",
    "By checking the box below I acknowledge I have read, understood, and agree to be bound by Alpaca Securities LLC and PARTNER account terms, and all other terms, disclosures and disclaimers applicable to me, as referenced in the Alpaca Customer Agreement. I also acknowledge that the Alpaca Customer Agreement contains a pre-dispute arbitration clause in Section 42.",
    "I understand I am signing this agreement electronically and that my electronic signature is the legal equivalent of my manual signature on this Agreement.",
  ],
  DISCLOSURES_MESSAGE:
    "Please click on the Alpaca Customer Agreement to continue.",
  LINK_ITEMS: [
    {
      label: "Investment Advisory Agreement",
      value:
        "https://drive.google.com/file/d/18Qhm1nofGsUbblOP5gctX1NHpUke1dDx/view?usp=sharing",
    },
    {
      label: "Alpaca Customer Agreement",
      value:
        "https://files.alpaca.markets/disclosures/library/AcctAppMarginAndCustAgmt.pdf",
    },
    {
      label: "Privacy Policy",
      value:
        "https://drive.google.com/file/d/15GonUJKelbPZuFXUTqnrKOZrCQFWaRdo/view?usp=sharing",
    },
    {
      label: "Form ADV 2A",
      value:
        "https://drive.google.com/file/d/1CFuQV6C-u73CCcqQxTWP7j7d8GWevaBM/view?usp=sharing",
    },
    {
      label: "Form CRS",
      value:
        "https://drive.google.com/file/d/18ScoJB1OnBtg85NPqojogQNu5dlKnQhX/view?usp=sharing",
    },
  ],
  DISCLOSURES_BOTTOM_HEADING:
    "I have read and agree to the Bright Investment Advisory Agreement, Customer Agreement Acknowledgement, Digital Signature Acknowledgement, Alpaca Customer Agreement, Privacy Policy, Form ADV, and Form CRS.",
  DISCLOSURES_BUTTON_HEADING: "Open My Account",
};
